import { useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { errorMessage } from "@/lib/api";
import { dohvatiDokumente, ucitajDokument, type DokumentDjelatnika } from "@/lib/dokumenti";
import { resolveEvidenceFile } from "@/lib/permitApplications";

export function CaseDocumentActions({ workerId, code, name, onLinked }: {
  workerId: string; code?: string; name: string; onLinked: (fileId: string, documentId: string) => Promise<void>;
}) {
  const { can } = useAuth();
  const [mode, setMode] = useState<"drawer" | "upload" | null>(null);
  const [documents, setDocuments] = useState<DokumentDjelatnika[]>([]);
  const [selected, setSelected] = useState("");
  const [file, setFile] = useState<File | null>(null);
  const [uploaded, setUploaded] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  async function drawer() {
    if (busy) return;
    setBusy(true); setError(""); setMode("drawer");
    try { setDocuments((await dohvatiDokumente(workerId, undefined, false, false)).filter(doc => doc.status === "active" && doc.has_content && (!code || doc.document_type_code === code))); }
    catch (cause) { setError(errorMessage(cause, "Ladica nije dostupna.")); }
    finally { setBusy(false); }
  }
  async function link() {
    if (busy || (mode === "drawer" ? !selected : !file)) return;
    setBusy(true); setError("");
    try {
      let id = mode === "drawer" ? selected : uploaded;
      if (!id && file && mode === "upload") {
        const result = await ucitajDokument(workerId, { documentTypeCode: code || "other_hr_document", naziv: name, datoteka: file });
        id = result.id; setUploaded(id);
      }
      if (!id) return;
      await onLinked(await resolveEvidenceFile(workerId, id), id);
      setMode(null); setFile(null); setUploaded(null); setSelected("");
    } catch (cause) { setError(errorMessage(cause, "Prilog nije povezan. Pokušajte ponovno.")); }
    finally { setBusy(false); }
  }
  if (!can("dokument", "read")) return <p>Za priloge je potrebna ovlast pregleda dokumenata.</p>;
  return <div className="w-full space-y-2"><div className="flex flex-wrap gap-2"><Button type="button" variant="secondary" disabled={busy} onClick={() => void drawer()}>Priloži iz Ladice</Button>{can("dokument", "create") && <Button type="button" variant="secondary" disabled={busy} onClick={() => { setMode("upload"); setError(""); }}>Učitaj</Button>}</div>
    {mode && <fieldset disabled={busy} className="space-y-2 rounded-lg border p-3"><legend>{name}</legend>{mode === "drawer" ? <><label className="block">Prilog: {name}<select className="min-h-11 w-full rounded border p-2" value={selected} onChange={event => setSelected(event.target.value)}><option value="">Odaberite dokument</option>{documents.map(doc => <option key={doc.id} value={doc.id}>{doc.display_title || doc.naziv || doc.document_type_name}</option>)}</select></label>{!documents.length && !busy && <p>Nema odgovarajućih priloga. <Link className="underline" to={`/zaposlenici/${workerId}?tab=dokumenti`}>Otvori Ladicu</Link></p>}</> : <label className="block">Datoteka: {name}<Input type="file" accept="application/pdf,image/jpeg,image/png" onChange={event => { setFile(event.target.files?.[0] || null); setUploaded(null); }} /></label>}<div className="flex flex-wrap gap-2"><Button type="button" variant="secondary" disabled={mode === "drawer" ? !selected : !file} onClick={() => void link()}>Poveži prilog</Button><Button type="button" variant="ghost" onClick={() => setMode(null)}>Odustani</Button></div></fieldset>}{error && <p role="alert">{error}</p>}</div>;
}
